/* PACKO side cart: reservation timer, the add-on button, and one shared
   "add to cart and open the drawer" helper that the product page uses too.

   The drawer's markup is replaced wholesale by Dawn after every cart change,
   so nothing here holds on to drawer elements: the timer looks its line up
   again on every tick, and the add-on button is handled by delegation. */
(function () {
  if (window.PackoCart) return;

  /* ---- Storage that survives a blocked localStorage ---- */

  var mem = {};
  function get(k) {
    try { return window.localStorage.getItem(k); } catch (e) { return mem[k] || null; }
  }
  function set(k, v) {
    try { window.localStorage.setItem(k, String(v)); } catch (e) { mem[k] = String(v); }
  }

  /* ---- Reservation timer ----
     A fresh reservation starts whenever the cart holds more items than it
     did on the last tick, i.e. after any add, wherever it happened. When
     the time runs out the line hides itself; the cart is left alone. */

  var UNTIL = 'packo_cd_until';
  var COUNT = 'packo_cd_count';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var el = document.querySelector('[data-packo-cd-timer]');
    if (!el) {
      if (document.querySelector('cart-drawer.is-empty')) set(COUNT, 0);
      return;
    }
    var count = parseInt(el.getAttribute('data-count'), 10) || 0;
    var mins = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var until = parseInt(get(UNTIL), 10) || 0;
    var last = parseInt(get(COUNT), 10) || 0;
    var now = Date.now();

    if (count > last || !until) {
      until = now + mins * 60000;
      set(UNTIL, until);
    }
    if (count !== last) set(COUNT, count);

    var left = Math.ceil((until - now) / 1000);
    if (left <= 0) {
      el.hidden = true;
      return;
    }
    var clock = el.querySelector('[data-packo-cd-clock]');
    if (clock) clock.textContent = Math.floor(left / 60) + ':' + pad(left % 60);
    el.hidden = false;
  }

  tick();
  setInterval(tick, 1000);

  /* ---- Add and open ---- */

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  /* Resolves with the drawer opened on the new cart. Rejects with the
     message Shopify gave (sold out, quantity limit) so the caller can
     show it where the customer is looking. */
  function add(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; });
      })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          throw new Error(res.json.description || res.json.message || 'error');
        }
        if (!drawer || typeof drawer.renderContents !== 'function' || !res.json.sections) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return res.json;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res.json);
        tick();
        return res.json;
      });
  }

  window.PackoCart = { add: add };

  /* ---- The add-on card inside the drawer ---- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-packo-cd-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    add([{ id: Number(btn.getAttribute('data-packo-cd-add')), quantity: 1 }]).catch(function (err) {
      btn.disabled = false;
      var box = document.getElementById('CartDrawer-CartErrors');
      if (box) box.textContent = err.message;
    });
  });

  /* ---- Phone sheet: a downward swipe on its handle or header closes it ---- */

  var y0 = null;
  document.addEventListener('touchstart', function (e) {
    var t = e.target.closest && e.target.closest('.packo-cd__grab, .packo-cd__header');
    y0 = t ? e.touches[0].clientY : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (y0 === null) return;
    var dy = e.changedTouches[0].clientY - y0;
    y0 = null;
    var drawer = document.querySelector('cart-drawer.active');
    if (dy > 60 && drawer && typeof drawer.close === 'function') drawer.close();
  }, { passive: true });
})();
